import { shallowMount } from "@vue/test-utils";
import ConsultaWrapper from "@/views/ConsultaWrapper";

describe("ConsultaWrapper component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ConsultaWrapper);
  });

  it("Renders del component ConsultaWrapper", () => {
    expect(wrapper).toBeDefined();
  });
});
